import { BrowserRouter as Router, Switch, Route } from "react-router-dom";
import React from "react";
import Headers from '../components/Main/Headers';
import Footers from '../components/Main/Footers';
import Home from '../containers/Home';
import About from '../containers/About';
import Papers from '../containers/Papers';
import Sponsorship from "../containers/Sponsorship";
import Registration from "../containers/Registration";
import RegistrationSuccess from "../containers/Registration/Success";
import Publications from "../containers/Publications";
import ContactUs from "../containers/ContactUs";
import Gallery from "../containers/Gallery";
import { homeContent2026 } from '../containers/Home/content';
import { aboutContent2026 } from '../containers/About/content';
import { papersContent2026 } from '../containers/Papers/content';
import { publicationsContent2026 } from '../containers/Publications/content';
import Registration2026 from "../containers/Registration2026";

import ErrorPage from "../containers/ErrorPage";
import { Layout } from 'antd';
const { Content } = Layout;

function App() {
  return (
    <Router>
      <Layout style={{ overflowX: 'hidden', position: 'relative', minHeight: '100vh', backgroundColor: '#fff' }}>
        <Headers />
        <Content className="site-layout" style={{ marginTop: 64, paddingBottom: '2.5rem' }}>
          <Switch>
            <Route exact path="/">
              <Home content={homeContent2026} />
            </Route>

            {/* Archive: WCHSS 2024 internal routes (reuse existing page containers) */}
            <Route exact path="/wchss-2024">
              <Home />
            </Route>
            <Route exact path="/wchss-2024/about">
              <About />
            </Route>
            <Route exact path="/wchss-2024/call-for-papers">
              <Papers />
            </Route>
            <Route exact path="/wchss-2024/publication">
              <Publications />
            </Route>
            <Route exact path="/wchss-2024/gallery">
              <Gallery />
            </Route>
            <Route exact path="/wchss-2024/contact">
              <ContactUs />
            </Route>

            {/* Archive: WCHSS 2026 internal routes (reuse existing page containers) */}
            <Route exact path="/wchss-2026">
              <Home content={homeContent2026} />
            </Route>
            <Route exact path="/wchss-2026/about">
              <About content={aboutContent2026} />
            </Route>
            <Route exact path="/wchss-2026/call-for-papers">
              <Papers content={papersContent2026} />
            </Route>
            <Route exact path="/wchss-2026/publication">
              <Publications content={publicationsContent2026} />
            </Route>
            <Route exact path="/wchss-2026/gallery">
              <Gallery />
            </Route>
            <Route exact path="/wchss-2026/contact">
              <ContactUs />
            </Route>

            <Route exact path="/wchss-2026/registration">
              <Registration2026 />
            </Route>

            <Route exact path="/about">
              <About content={aboutContent2026} />
            </Route>
            <Route exact path="/call-for-papers">
              <Papers content={papersContent2026} />
            </Route>
            <Route exact path="/sponsorship">
              <Sponsorship />
            </Route>
            <Route exact path="/publications">
              <Publications content={publicationsContent2026} />
            </Route>
            <Route exact path="/contact-us">
              <ContactUs />
            </Route>
            <Route exact path="/registration">
              <Registration />
            </Route>
            <Route exact path="/registration/success">
              <RegistrationSuccess />
            </Route>
            <Route exact path="/registration/payment-confirmation">
              <Registration />
            </Route>
            <Route exact path="/registration/check-status">
              <Registration />
            </Route>
            <Route exact path="/registration/info-and-payment-method">
              <Registration />
            </Route>
            <Route exact path="/gallery">
              <Gallery />
            </Route>
            <Route path="*">
              <ErrorPage />
            </Route>
          </Switch>
        </Content>
        <Footers style={{ position: 'absolute', bottom: 0, width: '100%', height: '2.5rem' }} />
      </Layout>
    </Router>
  );
}

export default App;
